import { Box, SxProps, Theme } from '@mui/material'
import { SitooLogo } from '@sitoo/mui-components'

type Props = {
  sx?: SxProps<Theme>
}

export const Logo = (props: Props) => {
  return <Box component={SitooLogo} sx={props.sx} />
}
